module.exports = __webpack_public_path__ + "img/event_warning.008ae247.svg";